import { Box } from "@mui/material";

import { MapPanel, MapPanelScrollableArea } from "~/modules/map/components/MapPanel";

import { TeamReportsHeader } from "./TeamReportsHeader";
import WorkerReportSkeleton from "./WorkerReport/WorkerReportSkeleton";

type TeamReportsPanelSkeletonProps = {
    backHref: string;
};

export function TeamReportsPanelSkeleton({ backHref }: TeamReportsPanelSkeletonProps) {
    return (
        <MapPanel>
            <TeamReportsHeader backHref={backHref} />

            <MapPanelScrollableArea sx={{ paddingBlock: 2 }}>
                {[1, 2, 3].map(i => (
                    <Box
                        key={i}
                        sx={theme => ({
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            paddingBlock: 2,
                            paddingInline: 2,
                        })}
                    >
                        <WorkerReportSkeleton />
                    </Box>
                ))}
            </MapPanelScrollableArea>
        </MapPanel>
    );
}
